import React from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';

type ContentMessageProps = {
  text: string | React.ReactNode;
  modifier?: Modifier<'padding-bottom'>;
};

export default function ContentMessage({ text, modifier }: ContentMessageProps) {
  return !text || text === '' ? null : <p className={bem('content-message', modifier)}>{text}</p>;
}
